import React from "react";
import { CEPInput, Input } from "../Input/Input";
import { Select } from "../Select/Select";
import { states } from "./CepAddressField.constants";
import { FormElement } from "../../sections/DynamicForm/DynamicForm.types";

interface CepAddressFieldProps {
  element: FormElement;
  commonProps: any;
  cepState: string;
  setCepState: (value: string) => void;
  stateValue: string;
  city: string;
  formStyles: any;
  handleFieldChange: (fieldName: string) => void;
}

export const CepAddressField: React.FC<CepAddressFieldProps> = ({
  element,
  commonProps,
  cepState,
  setCepState,
  stateValue,
  city,
  formStyles,
  handleFieldChange,
}) => {
  const fieldName = element.props.attribute_name;

  return (
    <React.Fragment>
      <CEPInput
        {...commonProps}
        value={cepState}
        onChange={e => {
          setCepState(e.target.value);
          if (fieldName) {
            handleFieldChange(fieldName);
          }
        }}
      />
      <Select
        options={states}
        disabled
        colorLabel={formStyles?.textColor}
        label="UF (Estado)"
        name="state"
        value={stateValue}
      />
      <Input
        colorLabel={formStyles?.textColor}
        label="Cidade"
        disabled
        placeholder="Digite o CEP"
        value={city}
        name="city"
      />
    </React.Fragment>
  );
};
